/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Cost_Tokens_RequestsInputs */



/**
* | output |
* | --- |
* | "Tokens ({count} requests)" |
*
* @param {Chat_Cost_Tokens_RequestsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_cost_tokens_requests = /** @type {((inputs: Chat_Cost_Tokens_RequestsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Cost_Tokens_RequestsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Tokens (${i?.count} Anfragen)`)
	return /** @type {LocalizedString} */ (`Tokens (${i?.count} requests)`)
});